import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {ViewModule} from 'app/views/view.module';
import {BillingService2} from "./billing.service";
import {BillingComponent} from "./billing/billing.component";
import {MoneyComponent} from "./money/money.component";
import {ExpiredPaidComponent} from "./expired_paid/expired_paid.component";
import {TailComponent} from "./tail/tail.component";
import {PromocodeInfoComponent} from "./billing/details/promocode_info/promocode_info.component";
import {MoneyDetailsComponent} from "./billing/details/money_details/money_details.component";
import {PaymentStructureComponent} from "./payment_structure/payment_structure.component";
import {PaymentStructureDetailComponent} from "./payment_structure/details/details.component";
import {PromocodeComponent} from "./promocode/promocode.component";
import {GeoComponent} from './geo/geo.component';
import {ReturnComponent} from "./return/return.component";
import {OperationDataComponent} from "./operation_data/operation_data.component";
import {TemplateBillingComponent} from "./template_billing/template_billing.component";
import {TemplateBillingDetailsComponent} from "./template_billing/details/template_billing_details.component";
import {RouterModule} from "@angular/router";
import {ErrorsComponent} from "./errors/errors.component";
import {ErrorsDetailsComponent} from "./errors/details/errors_details.component";
import {FriendComponent} from "./friend/friend.component";
import {FriendDetailsComponent} from "./friend/details/friend_details.component";
import {ConversionRateComponent} from "./conversion_rate/conversion_rate.component";
import { BalanceComponent } from './balance/balance.component';
import {UberComponent} from "./uber/uber.component";
import { ConversionComponent } from './conversion/conversion.component';
import {TrendComponent} from "./operation_data/trend.component";
import { ManualComponent } from './manual/manual.component';
import { OnesComponent } from './ones/ones.component';
import {ReactiveFormsModule} from "@angular/forms";
import { DisableRecurrentComponent } from './disable-recurrent/disable-recurrent.component';
import { WithdrawalsRecurrentComponent } from './withdrawals-recurrent/withdrawals-recurrent.component';
import { ConversionSourceComponent } from './conversion-source/conversion-source.component';
import { PromopultComponent } from './promopult/promopult.component';
import {ZeroDayComponent} from "./zero_day/zero_day.component";
import { UIModule } from "../ui/ui.module";

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		RouterModule,
		ReactiveFormsModule,
		UIModule,
	],
	declarations: [
		BillingComponent,
		MoneyComponent,
		PaymentStructureComponent,
		ExpiredPaidComponent,
		TailComponent,
		MoneyDetailsComponent,
		PromocodeInfoComponent,
		PaymentStructureDetailComponent,
		PromocodeComponent,
		ReturnComponent,
		GeoComponent,
		OperationDataComponent,
		TrendComponent,
		TemplateBillingComponent,
		TemplateBillingDetailsComponent,
		ErrorsComponent,
		ErrorsDetailsComponent,
		FriendComponent,
		FriendDetailsComponent,
		ConversionRateComponent,
		BalanceComponent,
		UberComponent,
		ConversionComponent,
		ManualComponent,
		OnesComponent,
		DisableRecurrentComponent,
		WithdrawalsRecurrentComponent,
		ConversionSourceComponent,
		PromopultComponent,
		ZeroDayComponent
	],

	providers: [
		BillingService2,
	],
	entryComponents: [
		MoneyDetailsComponent,
		PromocodeInfoComponent,
		PaymentStructureDetailComponent,
		TemplateBillingDetailsComponent,
		ErrorsDetailsComponent,
		FriendDetailsComponent
	]
})
export class BillingModule {
}
